import DOMPurify from "isomorphic-dompurify"

export function sanitize(string: string, tags: string[] = [], attributes = []) {
  return DOMPurify.sanitize(string, {
    ALLOWED_TAGS: tags,
    ADD_ATTR: attributes,
  })
}
